$(document).ready(function () {
  const p = $("body").attr("p");
  const locationId = $("body").attr("event_id");
  if (p === "electronic_journal") {
    let order_by = "reg_date";
    let order_by_direction = "desc";
    let page = 1;

    $("select").select2({
      theme: "bootstrap4",
    });

    //datepicker initialization
    $("#start-date").datepicker({
      dateFormat: "dd-mm-yy",
    });
    $("#end-date").datepicker({
      dateFormat: "dd-mm-yy",
    });

    //submit on change
    $(document).on(
      "change",
      "#start-date, #end-date, #event-type",
      function () {
        const startDate = $("#start-date").val();
        const endDate = $("#end-date").val();
        const eventType = $("#event-type").val();
        getElectronicJournalList(
          locationId,
          eventType,
          startDate,
          endDate,
          1,
          order_by,
          order_by_direction
        );
      }
    );

    $(document).on("click", ".pagination a", function (e) {
      e.preventDefault();
      page = parseInt($(this).attr("href").substring(6));
      let eventType = $("#event-type").val() ?? 0;
      let startDate = $("#start-date").val();
      let endDate = $("#end-date").val();

      getElectronicJournalList(
        locationId,
        eventType,
        startDate,
        endDate,
        page,
        order_by,
        order_by_direction
      );
    });

    $(document).on("click", ".sort", function (e) {
      e.preventDefault();
      let eventType = $("#event-type").val() ?? 0;
      let startDate = $("#start-date").val();
      let endDate = $("#end-date").val();
      order_by = $(this).attr("data-order-by");
      order_by_direction = $(this).attr("data-order-by-direction");

      getElectronicJournalList(
        locationId,
        eventType,
        startDate,
        endDate,
        page,
        order_by,
        order_by_direction
      );
    });

    $(document).on("click", ".show-details-button", function () {
      const journalId = $(this).attr("data-electronic-journal-id");
      const parentTr = $(this).closest("tr");
      const detailContainer = parentTr.next(
        ".electronic-journal-detail-container"
      );
      const showIconDiv = $(this).closest("tr").find(".show-detail-icon");
      const hideIconDiv = $(this).closest("tr").find(".hide-detail-icon");

      if (detailContainer.length > 0) {
        detailContainer.remove();
        showIconDiv.toggleClass("d-none");
        hideIconDiv.toggleClass("d-none");
        return;
      }

      $.ajax({
        type: "POST",
        url: "/api/v1/private/electronic-journal/get-detail",
        data: {
          journal_id: journalId,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            parentTr.after(
              '<tr class="electronic-journal-detail-container"><td colspan="100%" style="border:none">' +
                data.html +
                "</td></tr>"
            );
            setTimeout(() => {
              showIconDiv.toggleClass("d-none");
              hideIconDiv.toggleClass("d-none");
            }, 200);
          }
        })
        .fail(function (data) {
          if (data.responseJSON.redirect_url) {
            document.location.href = data.responseJSON.redirect_url;
          }

          if (data.error) {
            return alert(data.error);
          }
        });
    });

    $(document).on("click", "#electronic-journal-export", function (e) {
      e.preventDefault();
      const exportBtn = $(this);
      const originalBtnHtml = exportBtn.html();
      exportBtn.prop("disabled", true);
      exportBtn.html(
        '<div class="loader"></div>'
      );
      let eventType = $("#event-type").val() ?? 0;
      let startDate = $("#start-date").val();
      let endDate = $("#end-date").val();

      const queryParams = new URLSearchParams({
        location_id: locationId,
        event_type: eventType,
        start_date: startDate,
        end_date: endDate,
        order_by: order_by,
        order_by_direction: order_by_direction,
      }).toString();

      const exportUrl =
        "/api/v1/private/electronic-journal/export?" + queryParams;

      // Use $.ajax for more control, specifying dataType: 'text'
      $.ajax({
        url: exportUrl,
        method: 'GET',
        dataType: 'text', // Key fix: Treat response as raw text, not parsed XML
        success: function(data) {
          // 'data' is now the raw XML string

          // Create a Blob for the XML content
          var blob = new Blob([data], { type: 'application/xml' });

          // Create a temporary URL for the Blob
          var url = URL.createObjectURL(blob);

          // Create a hidden anchor element to trigger download
          var a = document.createElement('a');
          a.href = url;
          a.download = 'electronic-journal.xml'; // Set a meaningful filename
          document.body.appendChild(a);
          a.click(); // Simulate click to download

          // Clean up
          document.body.removeChild(a);
          URL.revokeObjectURL(url);
        },
        error: function(jqXHR, textStatus, errorThrown) {
          console.error('Error downloading XML:', textStatus, errorThrown);
          // Optionally, show an error message to the user
          alert('Failed to download the export. Please try again.');
        },
        complete: function() {
          // Restore the button state regardless of success or failure
          exportBtn.prop("disabled", false);
          exportBtn.html(originalBtnHtml);
        }
      });
    });

    function getElectronicJournalList(
      location_id = null,
      event_type,
      start_date,
      end_date,
      page = 1,
      order_by,
      order_by_direction
    ) {
      $.ajax({
        type: "POST",
        url: "/api/v1/private/electronic-journal/search",
        data: {
          location_id,
          event_type,
          start_date,
          end_date,
          page,
          order_by,
          order_by_direction,
        },
      })
        .done(function (data) {
          if (data.html !== undefined && data.html !== null) {
            $(".electronic-journal-view-content").empty();
            $(".electronic-journal-view-content").html(data.html);
          }
        })
        .fail(function (data) {
          if (data.responseJSON.redirect_url !== undefined && data.responseJSON.redirect_url !== null) {
              document.location.href = data.responseJSON.redirect_url;
          }

          if (data.error) {
            return alert(data.error);
          }
        });
    }
  }
});


function registerDrawerJournal(data) {
  if (data.action && data.action !== "unknown") {
    return $.ajax({
      type: "POST",
      url: "/api/v1/private/electronic-journal/drawer-journal",
      data: data,
    });
  }
}